// extracted by mini-css-extract-plugin
export default {"container":"text_container__23zcH","dropCap":"text_dropCap__1wED1","withIndent":"text_withIndent__wInSc","body":"text_body__1k8RS"};